module.exports = __webpack_public_path__ + "media/images/boxes/bip-box143-561bc68cfbdda6b744d25b1353dc1c4c.png";